import CookieService from "services/CookieService";

const config = {
  initConsent: CookieService.get("WIENICOOKIE_SOCIALS") === "allowed",
  handleOnClick: () => {
    // eslint-disable-next-line no-unused-expressions
    window.triggerCookieNotice ? window.triggerCookieNotice() : null;
  },
  addListener: false,
  message:
    "Hallo! Hier staat een bericht dat wij van Facebook, Instagram of Pinterest haalden. We kunnen het jou nu niet tonen omdat we toestemming van jou nodig hebben om cookies toe te laten. Klik op de groene knop hieronder om die toestemming te geven (= accepteer alle cookies en surf verder) en het bericht te lezen.",
};

export default config;
